import { render, staticRenderFns } from "./EditCalendar.vue?vue&type=template&id=4d33a96a&scoped=true&"
import script from "./EditCalendar.vue?vue&type=script&lang=js&"
export * from "./EditCalendar.vue?vue&type=script&lang=js&"
import style0 from "./EditCalendar.vue?vue&type=style&index=0&id=4d33a96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33a96a",
  null
  
)

export default component.exports